
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pomoc-video",
      function () {
        return require("private-next-pages/pomoc-video/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pomoc-video"])
      });
    }
  